import { useTranslation } from "react-i18next";
import React from "react";
import DashboardLayout from "../../../layouts/DashboardLayout";
import PageHeader from "../../../components/PageHeader";
import useIntegration from "../../../utils/useIntegration";
import SlashdataReportForm from "./forms/slashdata-report-form";
import ShafafiyaReportForm from "./forms/shafafiya-report-form";
function ReportList() {
  const { t } = useTranslation();
  const { integration } = useIntegration();
  return (
    <DashboardLayout>
      <PageHeader
        title={t("Reports")}
        description={t("report.generate_reports_description")}
      />

      <div className="mt-6">
        {integration?.integrationType === "slashdata" && (
          <>
            <SlashdataReportForm integration={integration} />
          </>
        )}
        {integration?.integrationType === "shafafiya" && (
          <>
            <ShafafiyaReportForm integration={integration} />
          </>
        )}
        {!integration && (
          <div className="flex items-center justify-center h-40 text-gray-500 font-light text-xl">
            {t("Select an integration from the sidebar to continue.")}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
export default ReportList;
